<div class="page">
    <div class="page-body" *ngIf="response.status == 1">
        <div class="page-title" *ngIf="page.mostrar_titulo">
            <div class="container">
                <h1 class="wow slideInUp">{{page.titulo}}</h1>
            </div>
        </div>
        <div class="page-content">
            <section class="section section-description wow fadeIn" *ngIf="page.mostrar_texto">
                <div class="container">
                    <div class="row"> 
                        <div class="col-md-12">
                            <article [innerHtml]="page.texto | safeHtml"></article>
                        </div>    
                    </div>    
                </div>
            </section>
            <div class="section section-agenda">
                <div class="container">
                    <div class="agenda-item" *ngFor="let a of agenda"> 
                        <h3 class="wow fadeIn" data-wow-delay="0.2s">{{a.mes_texto}} de {{a.ano}}</h3>
                        <div class="agenda-lista wow slideInUp"> 
                            <div class="row">
                                <div class="col-md-3" *ngFor="let e of a.eventos">
                                    <evento-item [data]="e"></evento-item> 
                                </div>    
                            </div>    
                        </div>    
                    </div>
                </div>
            </div>    
        </div>  
    </div>  
    <div class="page-body" *ngIf="response.status == 500">
        <page-error (reload)="getData()"></page-error>   
    </div>  
</div>    
<loader *ngIf="loader"></loader>